<template lang="pug">
div
  loading(
    v-if="isLoading"
    is-loading
  )

  template(v-else-if="isOnBackupCodesScreen")
    p.section Setup complete!
    p.section Please write down these backup codes.&#32;
      | They allow you to restore access to your account if you&#32;
      | lose access to your two-factor authentication codes. You&#32;
      | can then enter one of these instead. Note that eaach of these&#32;
      | codes can only be used once.

    pre.section.backup-codes
      | {{ backupCodesFormatted }}

    button(@click="$emit('setup-complete')").w-button.w-button--blue Ok

  template(v-else)
    .section(v-if="forced")
      p An administrator has enforced two factor authentication on this site.&#32;

    p.section Two-factor authentication setup is required to proceed.&#32;
      | Please download <b>Google Authenticator</b> app for&#32;
      a(href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en") Android&#32;
      | or&#32;
      a(href="https://itunes.apple.com/us/app/google-authenticator/id388497605") iPhone
      | .

    .section(v-if="seed")
      p Enter the provided key into the app:&#32;
        b(v-text="seed")

    .section(v-else)
      p Scan the barcode with the app:

      img.qr(src="/launchpad/2fa/login/setup/qr")

      p If you're unable to scan the barcode, you can&#32;
        a.seed-button(@click="getSeed") enter the key manually
        | .

    p.section After that, enter the 6-digit code that is shown in the app below:

    .w-input.code-input
      label(for="tfa-code").w-input__label Authentication code
      input#tfa-code(
        v-model="codeModel"
        autocomplete="one-time-code"
      ).w-input__input

    p.error.is-invalid(v-if="errorMessage") Error: {{ errorMessage }}

    button(@click="setupTfa").w-button.w-button--blue Verify
    button.w-button.w-button--link(@click="$emit('cancel')") Cancel

</template>

<script>
// eslint-disable-next-line @teamwork/cfb-rules/component-paths
import axios from 'axios';

import Loading from '@/components/widgets/Loading/Loading.vue';

export default {
  components: { Loading },

  props: {
    forced: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: false,
      errorMessage: undefined,

      isSeedShown: false,
      isOnBackupCodesScreen: false,

      seed: undefined,
      codeModel: undefined,
      backupCodes: undefined,
    };
  },

  computed: {
    backupCodesFormatted() {
      const halfSize = this.backupCodes.length / 2;

      return this.backupCodes
        .slice(0, halfSize)
        .map((code, index) => `${code}      ${this.backupCodes[halfSize + index]}`)
        .join('\n');
    },
  },

  methods: {
    async getSeed() {
      this.isLoading = true;
      this.errorMessage = undefined;

      try {
        const { data } = await axios.get('/launchpad/2fa/login/setup/secretkey.json');

        this.seed = data.secretKey;
      } catch (error) {
        this.errorMessage = 'Can\'t get 2FA seed, please try again later';
      }

      this.isLoading = false;
    },

    async setupTfa() {
      this.isLoading = true;
      this.errorMessage = undefined;

      try {
        const { data } = await axios.put('/launchpad/2fa/login/setup/complete.json', { VerificationCode: this.codeModel });

        this.backupCodes = data.codes;
        this.isOnBackupCodesScreen = true;
      } catch (error) {
        if (error.response.data && error.response.data.message) {
          this.errorMessage = error.response.data.message;
        } else {
          this.errorMessage = 'Can\'t setup 2FA, please try again later';
        }
      }

      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/variables/_variables.scss';

.section, .code-input, .error {
  margin-bottom: 24px;
}

.qr {
  width: 100%;
}

.seed-button {
  cursor: pointer
}

.error {
  color: $color--error;
}

.backup-codes {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// TfaSetup.vue?8adc4358